<div class="aza-activity-list">
  <div class="aza-activity-list-header">
  </div>
  <div class="aza-activity-list-items aza-vertical-stack">
    @for (activity of activitiesRes.activities; track activity.id) {
      <div
        class="aza-activity-list-item aza-activity-list-item-tabular-layout">
        <div (click)="onClicked(activity)" class="aza-vertical-stack aza-activity-list-item-name-column aza-flex-grow">
          <div class="aza-activity-list-item-name aza-text aza-heading activity-name">
            <span>{{activity.name}}</span>
          </div>
          <div class="activity-date-range">
            <div class="activity-start">
              <span translate>START</span>:
              <span>{{activity.start | eventDate:eventSettings.timezone:eventSettings.datetime_format}}</span>
            </div>
            <div class="activity-end">
              <span translate>END</span>:
              <span>{{activity.end | eventDate:eventSettings.timezone:eventSettings.datetime_format}}</span>
            </div>
          </div>
          @if (activity.speaker_info) {
            <div class="activity-speaker-info">
              <label class="activity-speaker-info-label" translate>SPEAKER_INFO</label>:
              <span>{{activity.speaker_info}}</span>
            </div>
          }
          @if (activity.room) {
            <div class="activity-room">
              <label class="activity-room-label" translate>ROOM</label>:
              <span>{{activity.room}}</span>
            </div>
          }
          <!-- <div *ngIf="activity.description" class="activity-description">
          <span translate>DESCRIPTION</span>:
          <span>{{activity.description}}</span>
        </div>
        <div *ngIf="activity.summary" class="activity-summary">
          <span translate>SUMMARY</span>:
          <span>{{activity.summary}}</span>
        </div>
        <div *ngIf="activity.url" class="activity-url">
          <span translate>URL</span>:
          <a [href]="activity.url">{{activity.url}}</a>
        </div> -->
      </div>
      <aza-rws-like-unlike [isLiked]="activity.liked" (liked)="onLikeActivity(activity)"
        (unliked)="onUnlikeActivity(activity)" class="activity-like-unlike">
      </aza-rws-like-unlike>
    </div>
  }
  @for (activity of activitiesRes.activities; track activity.id) {
    <div
      class="aza-activity-list-item aza-activity-list-item-vertical-layout">
      <div (click)="onClicked(activity)" class="aza-vertical-stack aza-flex-grow activity-name-start-end">
        <div class="aza-activity-list-item-name aza-text aza-heading activity-name">
          <span>{{activity.name}}</span>
        </div>
        <div class="activity-date-range">
          <div class="activity-start">
            <span translate>START</span>:
            <span>{{activity.start | eventDate:eventSettings.timezone:eventSettings.datetime_format}}</span>
          </div>
          <div class="activity-end">
            <span translate>END</span>:
            <span>{{activity.end | eventDate:eventSettings.timezone:eventSettings.datetime_format}}</span>
          </div>
        </div>
        @if (activity.speaker_info) {
          <div class="activity-speaker-info">
            <label class="activity-speaker-info-label" translate>SPEAKER_INFO</label>:
            <span>{{activity.speaker_info}}</span>
          </div>
        }
        @if (activity.room) {
          <div class="activity-room">
            <label class="activity-room-label" translate>ROOM</label>:
            <span>{{activity.room}}</span>
          </div>
        }
        <!-- <div *ngIf="activity.description" class="activity-description">
        <span translate>DESCRIPTION</span>:
        <span>{{activity.description}}</span>
      </div>
      <div *ngIf="activity.summary" class="activity-summary">
        <span translate>SUMMARY</span>:
        <span>{{activity.summary}}</span>
      </div>
      <div *ngIf="activity.url" class="activity-url">
        <span translate>URL</span>:
        <a [href]="activity.url">{{activity.url}}</a>
      </div> -->
    </div>
    <aza-rws-like-unlike [isLiked]="activity.liked" (liked)="onLikeActivity(activity)"
      (unliked)="onUnlikeActivity(activity)" class="activity-like-unlike">
    </aza-rws-like-unlike>
  </div>
}
</div>
<div class="aza-activity-list-paging">
  <aza-rws-pager (offsetChanged)="onPagingOffsetChanged($event)" [pagedResponseSubject]="pagedResponseSubject"
  [pageSize]="pagingOptions.limit"></aza-rws-pager>
</div>
</div>
